let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("9944g")).then(() => parcelRequire('kqRsv'));